import React, { useEffect, useState } from "react";
import { Container, Row, Col, ListGroup } from "react-bootstrap";
import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import Loader from "../../loader/Loader";

const TermsAndConditions = () => {
  const [loading, setloading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setloading(false);
    }, 500);
  }, []);

  window.intercomSettings = {
    api_base: "https://api-iam.intercom.io",
    app_id: "nedui962",
  };
  // We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/nedui962'
  (function () {
    var w = window;
    var ic = w.Intercom;
    if (typeof ic === "function") {
      ic("reattach_activator");
      ic("update", w.intercomSettings);
    } else {
      var d = document;
      var i = function () {
        i.c(arguments);
      };
      i.q = [];
      i.c = function (args) {
        i.q.push(args);
      };
      w.Intercom = i;
      var l = function () {
        var s = d.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        s.src = "https://widget.intercom.io/widget/nedui962";
        var x = d.getElementsByTagName("script")[0];
        x.parentNode.insertBefore(s, x);
      };
      if (document.readyState === "complete") {
        l();
      } else if (w.attachEvent) {
        w.attachEvent("onload", l);
      } else {
        w.addEventListener("load", l, false);
      }
    }
  })();
  return (
    <>
      <Header />
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="hero">
            <Container>
              <Row className="justify-content-center">
                <Col xl="17">
                  <h1 className="text-center mb-0">Terms and Conditions </h1>
                </Col>
              </Row>
            </Container>
          </div>
          <Container>
            <Row className="justify-content-center mb-11 mb-md-12 mb-xxl-13 mb-xxxl-14">
              <Col xl="18" xxl="16" xxxl="13">
                <p>Last updated: May 12, 2025 </p>
                <h3 className="h6">Introduction</h3>
                <p className="mb-7">
                  Welcome to Elderly Life. These Terms and Conditions (“Terms”)
                  govern your access to and use of the Elderly Life website and
                  software services (the “Service”). By accessing or using our
                  Service, you agree to be legally bound by these Terms. If you
                  do not agree, you must not use Elderly Life. These Terms form
                  a legal agreement between you and Elderly Life Ltd, a company
                  registered in England and Wales (Company No. 13256285). We may
                  update these Terms from time to time and will notify you of
                  any material changes. Continued use of the Service after
                  changes are posted constitutes your acceptance of the updated
                  Terms.
                </p>

                <h3 className="h6">The Service and Accounts</h3>
                <p className="mb-7">
                  Elderly Life is a Software-as-a-Service (SaaS) platform
                  accessible via our website (there is no mobile app). We grant
                  you a limited, non-exclusive, non-transferable licence to use
                  the Service for your personal or internal business purposes,
                  in accordance with these Terms. You must be 18 years or older
                  (or the age of legal majority in your jurisdiction) to use
                  Elderly Life. You are responsible for ensuring that any
                  information you provide to us is accurate and for keeping your
                  account credentials secure. You must notify us immediately at
                  support@elderlylife.com if you suspect any unauthorised use of
                  your account. You are responsible for all activities that
                  occur under your account.
                </p>

                <h3 className="h6">Pricing & Subscriptions</h3>
                <p>We offer subscription plans with the following terms: </p>
                <p>
                  Monthly Subscription: Billed monthly in advance. You may
                  cancel at any time by giving 30 days’ notice. After you submit
                  your cancellation, your subscription will remain active (and
                  you will retain platform access) for 30 days, and then it will
                  terminate. This effectively means you will continue to have
                  access (and be charged for service) for the 30-day notice
                  period after cancellation.
                </p>
                <p>
                  Annual Subscription: Billed as a one-year upfront payment. You
                  may cancel at any time to prevent renewal, but no refunds are
                  provided for any unused portion of the annual term. After
                  cancellation, your access will continue until the one-year
                  subscription period from the start date has concluded, and the
                  subscription will not renew. Annual plans may automatically
                  renew each year; if you do not wish to renew, you must cancel
                  before the renewal date. Cancelling an annual plan stops
                  future renewals but does not entitle you to a refund for the
                  current paid year.
                </p>
                <p className="mb-7">
                  Free Trial: We offer new users a one-month free trial at
                  sign-up. The free trial provides full access to Elderly Life
                  for 30 days at no charge. If you do not cancel before the
                  trial period ends, your account will automatically convert to
                  a paid subscription (monthly by default, unless you choose an
                  annual plan) and your provided payment method will be charged
                  the applicable subscription fees. Only one free trial per
                  user/household is permitted. We reserve the right to modify or
                  discontinue free trial offers at our discretion.
                </p>

                <h3 className="h6">Billing & Payment</h3>
                <p>
                  Payment Processor: All payments for Elderly Life subscriptions
                  are handled via a third-party payment processor, Stripe. We do
                  not store your credit/debit card details on our servers;
                  payment information is securely handled by Stripe in
                  compliance with PCI-DSS standards. By subscribing to Elderly
                  Life, you authorise us to charge your chosen payment method
                  through Stripe for recurring subscription fees. You agree to
                  be bound by Stripe’s terms and policies as applicable to the
                  payment processing, and you consent to our sharing of
                  necessary payment information with Stripe to complete
                  transactions.
                </p>

                <p>
                  Billing Cycle: Subscription fees are charged in advance on a
                  recurring basis (monthly plans are charged each month; annual
                  plans each year). The billing cycle begins on the date you
                  subscribe (or after the free trial ends, if applicable).
                  Charges are inclusive of any applicable taxes, unless
                  otherwise stated. You are responsible for any bank fees,
                  currency exchange fees, or other charges related to the
                  payment. All fees are in GBP (£) unless specified otherwise.
                </p>
                <p>
                  Price Changes: Elderly Life may adjust subscription prices
                  from time to time. We will provide you with at least 30 days’
                  notice of any price change via email or via the Service. If
                  you do not agree to the new price, you may cancel your
                  subscription before the new pricing takes effect; otherwise,
                  the new rate will apply from your next billing cycle.
                </p>
                <p className="mb-7">
                  Late Payment: It is your responsibility to ensure timely
                  payment of subscription fees. If we are unable to charge your
                  provided payment method (e.g. due to expiration or
                  insufficient funds), we will attempt to notify you and you
                  should update your payment details. If payment is overdue by
                  more than 7 days, we may suspend your access to the Service
                  until payment is received. If payment is not made within 14
                  days of the due date, we reserve the right to terminate your
                  subscription for non-payment. You will remain liable for any
                  unpaid amounts. We are not responsible for any bank fees or
                  charges incurred due to payment attempts.
                </p>

                <h3 className="h6">Cancellation and Termination </h3>
                <p>
                  Cancellation by You: You can cancel your Elderly Life
                  subscription at any time by contacting us at{" "}
                  <a href="mailto:support@elderlylife.com">
                    support@elderlylife.com
                  </a>{" "}
                  or using any cancellation feature provided on our website.
                  Cancellation will take effect after the required notice period
                  (30 days for monthly plans, or at the end of the annual term
                  for annual plans) as described in Section 3 above. During the
                  notice period, your subscription remains active and
                  accessible. After cancellation takes effect, you will lose
                  access to the platform and its features. No further recurring
                  charges will be made after the end of the notice period or
                  current term. No prorated refunds will be given for the
                  remaining period of a subscription that is cancelled after
                  payment (for example, no refund of unused months in an annual
                  plan).
                </p>

                <p>
                  Termination by Us: Elderly Life may terminate or suspend your
                  account or access to the Service: (a) for convenience, by
                  providing you at least 30 days’ notice via email (e.g., if we
                  decide to discontinue the Service or a particular subscription
                  offering); or (b) immediately (with or without notice) if you
                  materially breach these Terms, violate applicable laws, or
                  fail to pay fees when due. In the event of termination for
                  breach or non-payment, you will not be entitled to any refund
                  for any fees already paid, and we may immediately bar your
                  access to the Service. We will only charge you for services
                  provided up to the termination date.
                </p>

                <p className="mb-7">
                  Effect of Termination: Upon termination or cancellation of
                  your account, your right to use the Service will cease.
                  Sections of these Terms that by their nature should survive
                  termination (such as intellectual property rights,
                  disclaimers, liabilities, and data policy) will continue to
                  apply. If your account is terminated, we may delete or
                  deactivate your account and all related data, subject to the
                  data retention policy in Section 6 below.
                </p>

                <h3 className="h6">Data Policy</h3>

                <p>
                  Data Deletion Requests: You have the right to request deletion
                  of your personal data held by Elderly Life. To request
                  deletion, please contact us at support@elderlylife.com from
                  the email associated with your account. We will respond to
                  deletion requests and, subject to identity verification and
                  any legal obligations, will delete or anonymise your personal
                  data within a reasonable timeframe.
                </p>

                <p className="mb-7">
                  Data Retention: If you cancel your Elderly Life subscription
                  (or your account is terminated) and do not request data
                  deletion, we will retain your user data for one (1) year after
                  the cancellation/termination date. We retain data for this
                  period in case you reactivate your account or for other
                  legitimate business or legal purposes. After one year of
                  inactivity post-cancellation, we will permanently delete or
                  anonymise your personal data from our systems, except to the
                  extent we are required to keep it longer under applicable law.
                  Our handling of personal data is in accordance with our
                  Privacy Policy and applicable UK data protection laws
                  (including the UK GDPR).
                </p>

                <h3 className="h6">Third-Party Services and Links</h3>

                <p>
                  We use third-party services to help operate Elderly Life
                  efficiently and securely. These include:
                </p>

                <ListGroup className="br-none mb-7">
                  <ListGroup.Item>
                    Stripe for payment processing.
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Xero for accounting and invoicing.
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Intercom for customer support chat.
                  </ListGroup.Item>
                </ListGroup>

                <p>
                  These services may collect and process limited user data
                  necessary for their functions. Your use of the platform
                  indicates consent to these integrations, and your data may be
                  processed in accordance with their privacy policies.{" "}
                </p>

                <h3 className="h6">Contact Information</h3>

                <p>
                  If you have any questions about these Terms, or need to
                  contact us for any reason, please reach out to our support
                  team:
                </p>

                <p>
                  Email:{" "}
                  <a href="mailto:support@elderlylife.com">
                    support@elderlylife.com
                  </a>
                  <p>
                    Company Address: Unit H, Gateway 1000 Whittle Way,
                    Stevenage, England, SG1 2FP
                  </p>
                </p>

                <p>
                  Elderly Life values its users and strives to be transparent
                  and fair. Thank you for reading these Terms and for using
                  Elderly Life. We are here to support you and ensure that
                  Elderly Life is a helpful service for improving the lives of
                  the elderly and their families. If you have any concerns or
                  feedback regarding these Terms or the Service, please do not
                  hesitate to contact us.
                </p>

                <p>
                  By using the Service, you acknowledge that you have read,
                  understood, and agree to these Terms and Conditions in their
                  entirety.
                </p>
              </Col>
            </Row>
          </Container>
          <Footer />
        </>
      )}
    </>
  );
};

export default TermsAndConditions;
